import { useEffect, useState } from "react";
import { checkin, getUncheckedParticipantsLogs } from "./apiRoutes/events";
import {
  Loader2,
  TriangleAlert,
  CircleCheckBig,
  X,
  CheckCircle,
} from "lucide-react";
import { ClipLoader } from "react-spinners";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Sidebar from "../../customComponents/Sidebar/Sidebar";

const query = new URLSearchParams(window.location.search);

function EventAttendance() {
  const [key, setKey] = useState(query.get("key"));
  const [eventId, setEventId] = useState(query.get("id"));
  const [userId, setUserId] = useState(query.get("user"));
  const [attendanceCode, setAttendanceCode] = useState("");
  const [isFinished, setIsFinished] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [participantCodes, setParticipantCodes] = useState([]);

  const isAdmin = tmtAttendance.user_roles.includes("administrator");
  const isEventVolunteer = tmtAttendance.user_roles.includes("event_volunteer");

  if (!isAdmin && !isEventVolunteer) {
    window.location.href = "portal-login";
    return null;
  }

  const [completeDetails, setCompleteDetails] = useState(true);
  useEffect(() => {
    if (key && eventId && userId) {
      handleCheckinEvent();
    } else {
      setCompleteDetails(false);
    }
    initializeEventLogs();
  }, []);

  const handleStartLoading = () => {
    setIsLoading(true);
  };
  const handleStopLoading = () => {
    setIsLoading(false);
  };

  const handleCheckinEvent = async () => {
    handleStartLoading();
    const response = await checkin(userId, eventId, key, attendanceCode);
    handleStopLoading();
    setIsFinished(true);
    console.log(response);
  };

  const handleReset = () => {
    setIsFinished(false);
    setKey("");
    setEventId("");
    setUserId("");
    setParticipantCodes((prev) =>
      prev.filter((val) => val.label !== attendanceCode)
    );
    setAttendanceCode("");
  };

  const initializeEventLogs = async () => {
    const logs = await getUncheckedParticipantsLogs();
    const participants = logs.map((val) => ({
      label: val.code,
    }));
    setParticipantCodes(participants);
  };

  const loader = (
    <ClipLoader
      color="#1a73e8" // hex works
      size={140} // size in px
      cssOverride={{
        borderWidth: "8px", // default is 2-3px — increase to make it thicker
      }}
    />
  );

  const inputs = (
    <div className="input-container">
      <div>
        <p style={{ fontWeight: "bold", fontSize: "1.5rem" }}>
          Attendance Code
        </p>
        {/* <input
          type="text"
          value={attendanceCode}
          onChange={(e) => {
            setAttendanceCode(e.target.value);
          }}
        /> */}
        <Autocomplete
          disablePortal
          options={participantCodes}
          inputValue={attendanceCode}
          onInputChange={(event, newInputValue) => {
            console.log(newInputValue);
            setAttendanceCode(newInputValue);
          }}
          sx={{
            // width: 300,
            "& .MuiOutlinedInput-root": {
              borderRadius: 2,
              backgroundColor: "#f0f6ff",
              "& fieldset": {
                borderColor: "#2196f3", // blue border
              },
              "&:hover fieldset": {
                borderColor: "#1976d2", // darker blue on hover
              },
              "&.Mui-focused fieldset": {
                borderColor: "#1565c0", // even darker blue when focused
                boxShadow: "0 0 0 2px rgba(33, 150, 243, 0.2)",
              },
            },
            "& .MuiInputLabel-root": {
              color: "#1976d2",
            },
            "& .MuiAutocomplete-popupIndicator": {
              color: "#1976d2",
            },
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              sx={{
                "& .MuiOutlinedInput-input": {
                  border: "none",
                },
              }}
            />
          )}
        />
      </div>
      {/* <button onClick={handleCheckinEvent}>Submit</button> */}
      <button
        className={`ButtonW100 wpem-theme-button`}
        onClick={handleCheckinEvent}
        style={{ height: "3rem" }}
      >
        Submit
      </button>
    </div>
  );

  return (
    <div className="admin-portal-container">
      <Sidebar selectedIndex={1} />
      <div className="event-attendance-container">
        {isFinished ? (
          <div>
            <div className="finished-label">
              <CheckCircle size={40} color="#1a73e8" />
              <p>Attendance Logged</p>
            </div>
            <div>
              <button
                className={`ButtonW100 wpem-theme-button`}
                onClick={handleReset}
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  height: "3rem",
                }}
              >
                Log Another
              </button>
            </div>
          </div>
        ) : isLoading ? (
          loader
        ) : !completeDetails ? (
          inputs
        ) : (
          <div className=""></div>
        )}
      </div>
    </div>
  );
}

export default EventAttendance;
